import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MyHttpClient } from '../../http-client';

@Injectable({
  providedIn: 'root'
})
export class MakerCheckerService {
  constructor(private http: MyHttpClient) {}

  list(status?: string, pageNumber?: number, pageLimit?: number, base?: string): Observable<any> {
    const params = new URLSearchParams();
    if (status) {
      params.set('status', status);
    }
    if (pageNumber != null) {
      params.set('pageNumber', String(pageNumber));
    }
    if (pageLimit != null) {
      params.set('pageLimit', String(pageLimit));
    }
    const query = params.toString() ? `?${params.toString()}` : '';
    return this.http.get(`${this.approvalsRoot(base)}${query}`)
      .pipe(catchError(this.handleError));
  }

  approve(id: string, remark?: string, base?: string): Observable<any> {
    return this.http.post(`${this.approvalsRoot(base)}/${id}/approve`, { remark })
      .pipe(catchError(this.handleError));
  }

  reject(id: string, remark?: string, base?: string): Observable<any> {
    return this.http.post(`${this.approvalsRoot(base)}/${id}/reject`, { remark })
      .pipe(catchError(this.handleError));
  }

  private approvalsRoot(base?: string) {
    return base || `${environment.server}/api/limit-store/approvals`;
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}
